import React from 'react'
import MemberList from '../memberList/view'
import MemberDetail from '../memberDetail/view'

const Members = props => {
    const { member, members, setMember, setSelectedParticipant } = props
  
    return (
        <div>            
            {member === null && <MemberList members={members} setSelectedParticipant={setSelectedParticipant} />}
            {member !== null && <MemberDetail member={member} goBack={() => setMember(null)} />}
        </div>
    )
}

Members.propTypes = {}

export default Members
